import { useRef } from 'react';



const useLandingPageLoader = ({
    isSmartFlow,
    isLoading,
    digitalCategories,
    physicalCategories,
    supportsDigital,
    supportsPhysical
}) => {
    const hasEverLoaded = useRef(false);

    
    if (isSmartFlow) {
        return { showLoader: true };
    }

    const categoriesLoaded = !isLoading
        && (digitalCategories.size > 0 || physicalCategories.size > 0)
        && (supportsDigital !== undefined || supportsPhysical !== undefined);

    if (categoriesLoaded) {
        hasEverLoaded.current = true;
    }

    
    
    return { showLoader: !hasEverLoaded.current };
};

export default useLandingPageLoader;
